import type { BuyNodeV1Hook } from './types/buyNode.type';
import { type BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useBuyNodeV1 } from './v1';
import { useBuyNodeV2 } from './v2/useBuyNodeV2';

interface UseBuyNode extends BuyNodeV1Hook, BaseHookResult {}

export const useBuyNode = createVersionedHook<UseBuyNode>(
  {
    v1: useBuyNodeV1,
    v2: useBuyNodeV2,
  },
  'useBuyNode',
);
